<template>
  <PageBreadcrumb
    :crumbs="[{
      label: 'Gestione Imbottigliatori'
    }]"
  />

  <div class="flex justify-between mb-4">
    <div class="flex-grow">
      <SearchInput v-model="search" />
    </div>
    <div class="self-end">
      <ActionButton
        v-if="authStore.canManageUser"
        @click="router.push('/imbottigliatori/crea')"
      >
        <PlusCircleIcon class="w-5 h-5 inline-block" />
        Crea nuova Imbottigliatore
      </ActionButton>
    </div>
  </div>

  <DataTable :data="data">
    <template #heading>
      <tr>
        <SortableColumn
          v-model="sortStatus"
          name="name"
        >
          Nome
        </SortableColumn>
        <th class="text-right p-2" />
      </tr>
    </template>
    <template #body>
      <tr
        v-for="bottler in data"
        :key="'bottler-table-' + bottler.uuid"
        class="odd:bg-gray-100"
      >
        <td class="p-2">
          {{ bottler.name }}
        </td>
        <td class="p-2 text-right">
          <RouterLink
            v-if="authStore.canManageUser"
            title="Modifica Imbottigliatore"
            :to="'/imbottigliatori/' + bottler.uuid"
          >
            <PencilSquareIcon class="h-5 w-5 inline-block mx-1" />
          </RouterLink>
          <a
            v-if="authStore.canManageUser"
            href="#"
            title="Elimina Imbottigliatore"
            @click.prevent="destroy(bottler)"
          >
            <TrashIcon class="h-5 w-5 inline-block mx-1 " />
          </a>
        </td>
      </tr>
    </template>
  </DataTable>

  <DataTablePaginator
    :count="count"
    :count-all="countAll"
    :count-filtered="countFiltered"
    :current-page="currentPage"
    :has-next="hasNext"
    :has-prev="hasPrev"
    :next="next"
    :prev="prev"
    :total-pages="totalPages"
  />
</template>
    
<script setup>
import {
  PencilSquareIcon,
  PlusCircleIcon,
  TrashIcon
} from "@heroicons/vue/24/outline";
import { ref } from "vue";
import { useRouter } from 'vue-router'

import ActionButton from "@/components/ActionButton.vue";
import DataTable from "@/components/list/DataTable.vue";
import DataTablePaginator from "@/components/list/DataTablePaginator.vue";
import SearchInput from "@/components/list/SearchInput.vue";
import SortableColumn from "@/components/list/SortableColumn.vue";
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
import useDataTable from '@/composables/datatable.js'
import { useAuthStore } from '@/stores/auth'

const router = useRouter()
const authStore = useAuthStore()

const search = ref('')

const sortStatus = ref(["name", -1]);

const { data, count, countFiltered, countAll, currentPage, totalPages, next, prev, hasPrev, hasNext, action } = await useDataTable({
  endpoint: "/bottler/list",
  sortStatus,
  search,
  searchProperties: ['name']
})

const destroy = (bottler) => {
  action('delete', 'bottler/' + bottler.uuid, 'Imbottigliatore eliminato con successo')
}
</script>
